import { Box, Typography } from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import React from "react";
import dayjs from "dayjs";
import { SalesContainerValue } from "../../domain/AnalyticsSalesModel";

import "dayjs/locale/ru";

dayjs.locale("ru");

interface SalesContainerProps {
  title: string;
  periodStart: any;
  periodEnd: any;
  value: SalesContainerValue;
  diffValue: SalesContainerValue;
  index: number;
}

export const SalesContainer: React.FC<SalesContainerProps> = (props) => {
  return (
    <Box
      paddingRight="100px"
      paddingLeft={props.index > 0 ? "20px" : 0}
      sx={
        props.index % 2 !== 0
          ? {
              borderRight: 1,
              borderLeft: 1,
              borderColor: "##E8E8E9",
            }
          : {}
      }
    >
      <Typography fontSize="20px" fontWeight="600">
        {props.title}
      </Typography>

      <Box height={"25px"} />

      <Typography fontSize="18px" fontWeight="400" color="#656665">
        {dayjs(props.periodStart).format("DD MMMM YYYY")} -{" "}
        {dayjs(props.periodEnd).format("DD MMMM YYYY")}
      </Typography>

      <Box height={"5px"} />
      <Typography fontSize="40px" fontWeight="700" color={props.value.color}>
        {props.value.value}
      </Typography>

      <Box height={"15px"} />

      <SalesContainerFooter value={props.diffValue} />
    </Box>
  );
};

interface SalesContainerFooterProps {
  value: SalesContainerValue;
}
interface DiffIndicatorProps {
  change: "up" | "down" | "neutral";
}

const DiffIndicator: React.FC<DiffIndicatorProps> = (props) => {
  const colorConfig: { [key: string]: string } = {
    up: "#189C4B",
    down: "#C14461",
    neutral: "#E8E8E9",
  };

  const iconConfig: { [key: string]: React.ReactNode } = {
    up: <ArrowDropUpRoundedIcon sx={{ fill: "white" }} />,
    down: <ArrowDropDownRoundedIcon sx={{ fill: "white" }} />,
    neutral: <Box />,
  };

  return (
    <Box
      bgcolor={colorConfig[props.change]}
      borderRadius={"1000px"}
      width={"18px"}
      height={"18px"}
      alignContent={"center"}
      alignItems={"center"}
      justifyItems={"center"}
      justifyContent={"center"}
      display={"flex"}
    >
      {iconConfig[props.change]}
    </Box>
  );
};

export const SalesContainerFooter: React.FC<SalesContainerFooterProps> = (
  props
) => {
  return (
    <Box display={"flex"} flexDirection={"row"}>
      <DiffIndicator change={props.value.change} />
      <Box width={"10px"}></Box>

      <Box>
        <Typography color={"#656665"} fontSize={"16px"}>
          {props.value.value}
        </Typography>
        {props.value.subValue && (
          <Typography color={"#656665"} fontSize={"16px"}>
            {props.value.subValue}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
